const filters = document.querySelector('[data-filters]')

const getFilterData = (filterElements) => {
    let obj = {},
        checked,
        checkedValues

    filterElements.forEach((target, _index) => {
        const { type, name, value } = target

        if (type === 'radio' || type === 'checkbox') {
            if (!obj[name]) {
                checked = filters.querySelectorAll(`input[name='${name}']:checked`)
                checkedValues = []
                checked.forEach((c) => {
                    checkedValues.push(c.value)
                })

                obj = {
                    ...obj,
                    [name]: checkedValues.join(','),
                }
            }
        } else {
            obj = {
                ...obj,
                [name]: value,
            }
        }
    })
    return obj
}

const obj2QueryString = (obj) => {
    return Object.keys(obj)
        .map((key) => {
            const val = String(obj[key] ?? '').split(',')
            if (val.length > 1) {
                return val
                    .map((v) => {
                        return encodeURIComponent(key) + '=' + encodeURIComponent(v)
                    })
                    .join('&')
            } else {
                return encodeURIComponent(key) + '=' + encodeURIComponent(val[0])
            }
        })
        .join('&')
}

const _queryString2Obj = (str) => {
    if (!str.length) return {}
    const arr = str.split('&')
    const obj = arr.reduce((o, v) => {
        o[v.split('=')[0]] = v.split('=')[1]
        return o
    }, {})
    return obj
}

const getContent = (filterElements) => {
    const data = getFilterData(filterElements)
    const newQ = obj2QueryString(data)

    const oldListingContainer = document.querySelector('[data-filtered-content]')
    const loader = document.createElement('div')
    loader.setAttribute('class', 'loader')
    if (oldListingContainer) {
        oldListingContainer.prepend(loader)
    } else {
        console.warn('Container for prepend not found!')
    }

    const newLocation = location.origin + location.pathname + '?' + newQ

    fetch(newLocation)
        .then((response) => {
            history.pushState('', '', newLocation)
            return response.text()
        })
        .then((data) => {
            const parser = new DOMParser()
            const htmlResponse = parser.parseFromString(data, 'text/html')
            const newListingContainer =
                htmlResponse.documentElement.querySelector('[data-filtered-content]')
            if (oldListingContainer) {
                oldListingContainer.innerHTML = newListingContainer.innerHTML
            } else {
                console.warn('Container for innerHTML not found!')
            }

            // init_calendars()
        })
        .catch((error) => {
            console.error('Filter fetch failed:', error)
        })
}

const initListeners = (filterElements) => {
    Array.prototype.forEach.call(filterElements, (element) => {
        element.addEventListener(
            'change',
            () => {
                getContent(filterElements)
            },
            false
        )
    })

    // Delegated on document.body (rather than bound to individual buttons)
    // so filter/submit/option buttons keep working after getContent() swaps
    // in new markup via innerHTML — direct listeners would be lost with the
    // replaced elements.
    document.body.addEventListener('click', function (event) {
        if (event.target.dataset.filtersUpdate !== undefined) {
            getContent(filterElements)
            return
        }

        const submitButton = event.target.closest("button[type='submit']")
        if (submitButton) {
            event.preventDefault()
            getContent(filterElements)
            return
        }

        const optionButton = event.target.closest("button[type='button'].option")
        if (optionButton) {
            setTimeout(() => {
                event.preventDefault()
                getContent(filterElements)
            }, 200)
        }
    })
}

const initFilters = (filters) => {
    if (!filters) {
        return
    }

    const filterElements = filters.querySelectorAll(`select, input`)

    if (!filterElements.length) {
        return
    }

    getFilterData(filterElements)
    initListeners(filterElements)
}

initFilters(filters)
